import React, { useState } from 'react';
import vl from '../images/vl.svg'
import business from '../images/business.svg'
import StarRating from './rating';

const Card = ({ id,name, rating, recommendationCount,categoryName, physicalAddress,profileImage,categoryId }) => {
  physicalAddress = physicalAddress ? physicalAddress : ''
  name = name ? name : ''
    const goSingle = () => {
        sessionStorage.setItem('businessId',id)
        sessionStorage.setItem('categoryId',categoryId)
        sessionStorage.setItem('businessName',name)
        sessionStorage.setItem('currentCategory',categoryName? categoryName : sessionStorage.getItem('currentCategory'))
        window.location.href='/business-details/'+id
    }
    const [loaded, setLoaded] = useState(false);

    return (
        <div onClick={goSingle} onKeyDown={(event) => { if (event.key === 'Enter') goSingle() }} role="link" tabIndex={0} className="cursor-pointer overflow-hidden rounded-lg border-[1px] border-[#EDEDED] bg-white transition duration-200 hover:-translate-y-0.5 hover:shadow-[0_10px_24px_rgba(18,18,18,0.08)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#008B39]">
            <div className="relative border-b-[1px]">
                              <div
                className="relative flex h-48 w-full items-center justify-center overflow-hidden bg-gray-100"
                >
                <img
                    src={profileImage?.originalUrl || business}
                    alt={name}
                    className={`h-full w-full object-cover transition-opacity duration-300 ${loaded ? 'opacity-100' : 'opacity-0'}`}
                    onLoad={() => setLoaded(true)}
                />
                </div>
            </div>
            <div className="p-4 text-start h-[155px]">
                <div className="flex flex-row space-x-3 items-center">
                  <div className="lg:text-[22px] text-[18px] font-[500]">
                    {name.length > 19 
                    ? name.slice(0, 19) + "..." 
                    : name}
                  </div>
                  <div className='bg-[#01D65914] px-1 rounded-[20px] my-auto mx-auto text-[#008B39] text-center text-[10px]'>{categoryName ? categoryName : sessionStorage.getItem('currentCategory')}</div>
                </div>
                <div className="flex items-center mb-2">
                    {/* Render the stars */}
                    <StarRating 
                                    rating={rating} 
                                    maxRating={5} 
                                    readOnly 
                                />
                    <span className='ml-2'><img src={vl} /></span>
                    <span className="ml-2 text-sm text-gray-600">
                        {recommendationCount} Recommendations
                    </span>
                </div>
                <p className="text-gray-700 text-sm">
                  {physicalAddress.length > 95 
                    ? physicalAddress.slice(0, 95) + "..." 
                    : physicalAddress}
                </p>
            </div>
        </div>
    );
};

export default Card;